import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AbstractValueAccessor } from 'app/scripts/utils/AbstractValueAccessor';
import { valueAccessorProvider } from 'app/scripts/utils/provider-builders';

@Component({
  selector: 'woo-text-input',
  template: `
    <div class="input__container">
      @if (inputOptionalText()) {
      <span class="input__optional__text">{{ inputOptionalText() }}</span>
      }
      <label for="{{ inputId() }}">{{ labelText() }}</label>
      <input
        type="text"
        name="{{ name() }}"
        id="{{ inputId() }}"
        maxlength="{{ maxlength() }}"
        [(ngModel)]="model"
        (ngModelChange)="changes()"
        [disabled]="disabled()"
        [required]="required()"
        [placeholder]="placeholder()"
        #field="ngModel"
      />
      @if (!hideValidationIcons()) { @if (field.invalid && field.dirty) {
      <div class="status-badge small input__status error">
        <span class="icon-close-x icon__small"></span>
      </div>
      } @if (field.valid && field.dirty) {
      <div class="status-badge small input__status green-success">
        <span class="icon-check icon__small"></span>
      </div>
      } }
    </div>
  `,
  providers: [valueAccessorProvider(WooTextInput)],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class WooTextInput extends AbstractValueAccessor<string> {
  readonly inputId = input<string>('');
  readonly labelText = input<string>('');
  readonly disabled = input(false);
  readonly name = input<string>('');
  readonly maxlength = input<number>();
  readonly inputOptionalText = input<string>('');
  readonly required = input(false);
  readonly hideValidationIcons = input(false);
  readonly e2eId = input<string>('');
  readonly placeholder = input<string>('');
  readonly removeBlankSpaces = input(false);

  readonly inputValueChanged = output<string>();

  changes(): void {
    if (this.removeBlankSpaces()) {
      this.propagateChange(this.model.trim());
    }
  }
}
